module.exports = __webpack_public_path__ + "static/media/ic_hi_b4_fisdom.60a73a9e.svg";